import { compact } from 'lodash'
import { FormSchema } from 'components/Wizards/Wizard/Form/Types'
import { MOST_POPULAR_CHANNELS } from 'components/Wizards/Catalogue/Sections/Types'
import { Category } from 'screens/blaze/Home/components/Catalogue/Types'
import { categoryItems } from 'screens/blaze/Search/utils'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { TextChannelKey } from 'types'

export const getPopularItems = (filteredCategories: Category[]) =>
  compact(
    MOST_POPULAR_CHANNELS?.map((channel) =>
      categoryItems(filteredCategories)?.find(
        (item) => (item.extraProps as { schema: FormSchema })?.schema.describe().meta.type === channel,
      ),
    ),
  )

export const isMultipostType = (type: TextChannelKey) => {
  switch (type) {
    case GenerationType.InstagramPlanning:
    case GenerationType.LinkedInPlanning:
    case GenerationType.FacebookPlanning:
    case GenerationType.TwitterPlanning:
    case GenerationType.SEOPlanning:
      return true
    default:
      return false
  }
}
